<template>
  <div class="c">
    <div class="c-title">
      <span class="overview-head">
        <div class="overview-head__num">02</div>
        <div class="overview-head__title">测评学业分析</div>
      </span>
      <span class="c-title__analysis">表示班级发布过该测评（若一个测评测试过多次，将取最新一次布置的数据）</span>
    </div>
    <div class="academic">
    <div class="academic-name">
      <div
        @click.stop="switchOptions"
        class="academic-name__course pointer"
        >
          {{conditionNameList.subjectName}} /
          {{conditionNameList.versionsName}} /
          {{conditionNameList.gradeName}}
        <i class="el-icon-arrow-down"></i>
      </div>
      <div v-if="isChangeShow" class="change-select" @click.stop>
        <div class="change-select__down cb3">
          <div
            class="change-select__down__subject pointer"
            @click="subjectClick(subject)"
            :class="{'active':subject.dl_subject_id ===conditionList.dLSubjectId }"
            v-for="subject in subjectList"
            :key="subject.dl_subject_id">
            {{subject.code_name}}
          </div>
        </div>
        <div class="change-select__down">
          <div
            class="change-select__down__subject pointer"
            v-for="item in versionsList"
            @click="versionClick(item)"
            :class="{'active':item.dl_versions_id ===conditionList.bookVersionId }"
            :key="item.dl_versions_id">
            {{item.versions_name}}
          </div>
        </div>
        <div class="change-select__down">
          <div
            class="change-select__down__subject pointer"
            @click="gradeClick(grade)"
            :class="{'active':grade.grade_id === conditionList.gradeId }"
            v-for="grade in gradeList"
            :key="grade.dl_grade_id">
            {{grade.grade_name}}
          </div>
        </div>
      </div>
      <div class="academic-name__list">
        <div
          class="academic-name__list__model pointer"
          @click="testChange(item)"
          :class="{'active':item.test_id === conditionList.testId }"
          v-for="item in testList"
          :key="item.section_ids">
          <div :class="item.is_issue ? 'radius' : 'noradius' "></div>
          {{item.test_name}}
        </div>
      </div>
    </div>
    <div class="academic-list">
      <data-presentation
        :data="knowledgeList"
        :testName="conditionNameList.testName"
        :basicInfo="basicInfo"
        :edges="edges"
       />
    </div>
    </div>
  </div>
</template>

<script>
import { getAccurateCategory, getClassKnowledgeAtlas } from '@/api/pt';
import DataPresentation from './data-presentation.vue';

export default {
  name: 'AcademicAnalysis',
  components: {
    DataPresentation,
  },
  props: {
    classId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isChangeShow: false,
      subjectList: [],
      versionsList: [],
      gradeList: [],
      classList: [],
      testList: [],
      knowledgeList: [],
      conditionList: {
        crmSubjectId: '',
        dLSubjectId: '',
        bookVersionId: '',
        gradeId: '', //
        crmGradeId: '',
        testId: '',
        courseCode: '',
        sectionsId: '',
      },
      basicInfo: {},
      conditionNameList: {
        subjectName: '',
        versionsName: '',
        gradeName: '',
        testName: '',
      },
    };
  },
  computed: {
    edges() {
      if (!this.knowledgeList || !this.knowledgeList.length) {
        return [];
      }
      return this.knowledgeList.reduce((prev, cur) => {
        if (!cur.pre_lo_list || !cur.pre_lo_list.length) {
          return prev;
        }
        return prev.concat(cur.pre_lo_list.map((item) => ({
          source: item,
          target: cur.id,
        })));
      }, []);
    },
  },
  mounted() {
    document.addEventListener('click', this.bodyCloseMenus);
    this.getAccurateCategory('subjects');
  },
  watch: {
    classId() {
      this.getAccurateCategory('test');
      this.getClassKnowledgeAtlas();
    },
  },
  methods: {
    switchOptions() {
      this.isChangeShow = !this.isChangeShow;
    },
    bodyCloseMenus() {
      if (this.isChangeShow === true) {
        this.isChangeShow = false;
      }
    },
    subjectClick(subject) { // 切换学科
      this.knowledgeList = [];
      console.log(subject);
      this.conditionList.crmSubjectId = subject.crm_subject_id;
      this.conditionList.dLSubjectId = subject.dl_subject_id;
      this.conditionNameList.subjectName = subject.code_name;
      this.getAccurateCategory('versions');
    },
    versionClick(value) { // 切换版本
      this.knowledgeList = [];
      this.conditionList.bookVersionId = value.dl_versions_id;
      this.conditionNameList.versionsName = value.versions_name;
      this.getAccurateCategory('grade');
    },
    gradeClick(grade) { // 切换年级
      this.knowledgeList = [];
      this.conditionList.gradeId = grade.grade_id;
      this.conditionList.crmGradeId = grade.crm_grade_id;
      this.conditionNameList.gradeName = grade.grade_name;
      this.getAccurateCategory('test');
      this.isChangeShow = false;
    },
    testChange(item) { // 课程切换
      this.conditionList.testId = item.test_id;
      this.conditionNameList.testName = item.test_name;
      this.conditionList.courseCode = item.course_code;
      this.conditionList.sectionsId = item.section_ids;
      this.getClassKnowledgeAtlas();
    },
    getClassKnowledgeAtlas() { // 课程列表
      getClassKnowledgeAtlas({
        course_code: this.conditionList.courseCode,
        test_id: this.conditionList.testId,
        section_ids: this.conditionList.sectionsId,
        subject_id: this.conditionList.dLSubjectId,
        textbook_id: this.conditionList.bookVersionId,
        class_id: this.classId,
      }).then((res) => {
        this.knowledgeList = res.data.knowledge_list;
        this.basicInfo = res.data.basic_info;
        this.getKnowledgeList();
      });
    },
    getKnowledgeList() {
      this.knowledgeList = this.knowledgeList.map((item) => {
        let category = '未学习(-1)';
        if (item.avg_score >= 81) {
          category = '掌握熟练(80~100%)';
        } else if (item.avg_score >= 61) {
          category = '掌握较好(60~79%)';
        } else if (item.avg_score >= 41) {
          category = '掌握一般(40~59%)';
        } else if (item.avg_score >= 21) {
          category = '掌握较弱(20~39%)';
        } else if (item.avg_score >= 0) {
          category = '未掌握(0~19%)';
        }
        return {
          ...item,
          id: item.knowledge_code,
          name: item.knowledge_name,
          category,
        };
      });
    },
    getAccurateCategory(type) {
      getAccurateCategory({
        type,
        crm_subject_id: this.conditionList.crmSubjectId,
        dl_subject_id: this.conditionList.dLSubjectId,
        book_version_id: this.conditionList.bookVersionId,
        grade_id: this.conditionList.gradeId,
        crm_grade_id: this.conditionList.crmGradeId,
        class_id: this.classId,
      }).then((res) => {
        if (res.code === 200) {
          if (type === 'subjects') {
            this.subjectList = res.data;
            this.conditionList.crmSubjectId = this.subjectList[0].crm_subject_id;
            this.conditionList.dLSubjectId = this.subjectList[0].dl_subject_id;
            this.conditionNameList.subjectName = this.subjectList[0].code_name;
            this.getAccurateCategory('versions');
          }
          if (type === 'versions') {
            this.versionsList = res.data;
            this.conditionList.bookVersionId = this.versionsList[0].dl_versions_id;
            this.conditionNameList.versionsName = this.versionsList[0].versions_name;
            this.getAccurateCategory('grade');
          }
          if (type === 'grade') {
            this.gradeList = res.data;
            this.conditionList.gradeId = this.gradeList[0].grade_id;
            this.conditionList.crmGradeId = this.gradeList[0].crm_grade_id;
            this.conditionNameList.gradeName = this.gradeList[0].grade_name;
            this.getAccurateCategory('test');
          }
          if (type === 'test') {
            this.testList = res.data;
            if (this.testList.length > 0) {
              this.conditionList.courseCode = this.testList[0].course_code;
              this.conditionList.testId = this.testList[0].test_id;
              this.conditionNameList.testName = this.testList[0].test_name;
              this.conditionList.sectionsId = this.testList[0].section_ids;
              this.getClassKnowledgeAtlas();
            } else {
              this.conditionList.courseCode = '';
              this.conditionList.testId = '';
              this.conditionNameList.testName = '';
              this.conditionList.sectionsId = '';
              // this.basicInfo = {};
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .c {
    box-sizing: border-box;
    &-title {
      display: flex;
      margin-bottom: 33px;
      align-items: center;
      .overview-head{
      display: flex;
      margin-right: 51px;
      align-items: center;

      &__num{
        font-size: 22px;

        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        margin-right: 14px;
        background:url('~@/views/pt/images/class_bg.png');
        background-size:cover;
        width:38px;
        height:29px;
        line-height: 29px;
        text-align: center;
      }
      &__title{
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
      }
      }
      &__name {
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        line-height: 24px;
        margin-right: 51px;
      }
      &__analysis {
        &::before {
          content: '';
          display: inline-block;
          width: 10px;
          height: 10px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: #3BDE93;
        }
      }
    }
    .academic {
      box-sizing: border-box;
      display: flex;
      height: 591px;
      border: 1px solid #CDDEE9;
      &-name {
        width: 242px;
        &__course {
          position: relative;
          width: 243px;
          height: 40px;
          text-indent: 7px;
          line-height: 40px;
          color: #fff;
          background: #0091FF;
          i {
            position: absolute;
            right: 16px;
            top: 10px;
          }
        }
        &__list {
          height: 552px;
          overflow: hidden;
          overflow-y: auto;
          border-right: 1px solid #DEE3F1;
          background-color: #F5FBFF;
          &__model {
            font-size: 14px;
            text-indent: 18px;
            line-height: 48px;
            font-weight:500 ;
            border-bottom: 1px solid #DEE3F1;
            overflow:hidden; //超出的文本隐藏
            text-overflow:ellipsis; //溢出用省略号显示
            white-space:nowrap; //溢出不换行
          }
          &::-webkit-scrollbar{
            width:5px;
            height:5px;
            /**/
          }
          &::-webkit-scrollbar-track{
            background: #DEE3F1;
            border-radius:2px;
          }
          &::-webkit-scrollbar-thumb{
            background: #75BAFF;
            border-radius:10px;
          }
          &::-webkit-scrollbar-thumb:hover{
            background: #999;
          }
          &::-webkit-scrollbar-corner{
            background: #204754;
          }
        }
      }
      &-list {
        display: flex;
        padding: 10px 18px 10px 31px;
        flex: 1;
      }
    }
  }
  .active {
      color: #1890FF;
    }
    .radius {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 8px;
      border-radius: 50%;
      background-color: #3BDE93;
    }
    .noradius {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 8px;
      border-radius: 50%;
       opacity: 0;
    }
  .change-select {
      display: flex;
      justify-content: space-around;
      overflow-y: auto;
      width: 242px;
      height: 300px;
      color: #586077;
      position: absolute;
      background: #F8FAFF;
      box-shadow: 0 0 5px #586077;
      &__down {
        width: 78px;
        height: 480px;
        // border-left: 1px solid #E6E9F0;
        &__subject {
          width: 78px;
          line-height: 40px;
          margin: 0 auto;
          // border-bottom: 1px solid #E6E9F0;
          text-align: center;
          font-size: 16px;
        }
      }
      .cb3 {
        background-color: #F8FAFF;
      }
      &::-webkit-scrollbar{
          width:5px;
          height:5px;
          /**/
        }
        &::-webkit-scrollbar-track{
          background: rgba(196, 200, 210, 0.3);
          border-radius:2px;
        }
        &::-webkit-scrollbar-thumb{
          background: #75BAFF;
          border-radius:10px;
        }
        &::-webkit-scrollbar-thumb:hover{
          background: #999;
        }
        &::-webkit-scrollbar-corner{
          background: #204754;
        }
    }
</style>
